import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

export const useUpdateCustomer = (id: string) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/contacts/customers/${id}`,
    (url: string, { arg }: { arg: { isProductOrderRequired?: boolean; description?: string } }) =>
      fetcher(url, {
        method: "PUT",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to update customer information, please try again later", "error");
      },
    }
  );

  return {
    updateCustomer: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
